import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'

import RewardIcon from './reward-icon'

const styles = require('./styles.scss')

const IncentivesHeader = () => (
  <div className={styles.header}>
    <ThemeConsumer>
      {({ colorSecondary }) => <RewardIcon className={styles.headerIcon} color={colorSecondary} />}
    </ThemeConsumer>
    <p>
      <strong>Special Offer:</strong> Receive a welcome bonus of up to $100 when you fund a loan through one of our
      partner links*
    </p>
  </div>
)

export default IncentivesHeader
